/**
 * @fileoverview Main email and website fields for the Contact Information section.
 */

import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { IconButton } from "@mui/material";
import { ReactComponent as MailIcon } from "../../../assets/icons/ContactInformation/MailIcon.svg";
import { ReactComponent as WebsiteIcon } from "../../../assets/icons/ContactInformation/WebsiteIcon.svg";
import styles from "./ContactInformation.module.css";

/** Translation key for "show in profile" toggle label */
const SHOW_IN_PROFILE_KEY = "components.contactInformation.showInProfile";

export function MainEmailField({ section }) {
  const {
    t,
    isTablet,
    correoElectronicoPrincipal,
    setCorreoElectronicoPrincipal,
    getFieldValidationState,
    getErrorMessage,
    handleValidatedFieldChange,
    showEmail,
    setShowEmail,
    handleToggleChange,
  } = section;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t("components.contactInformation.mainEmailAddressLabel")}
      </label>
      <div className={styles.inputWrapper}>
        <MailIcon
          className={`${styles.inputIcon} ${
            isTablet ? styles.tabletInputIcon : ""
          }`}
        />
        <input
          type="email"
          className={`${styles.input} ${styles.inputWithIcon} ${
            getFieldValidationState(
              "correoElectronicoPrincipal",
              correoElectronicoPrincipal,
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t(
            "components.contactInformation.mainEmailAddressPlaceholder",
          )}
          value={correoElectronicoPrincipal}
          onChange={(e) => {
            const value = e.target.value;
            setCorreoElectronicoPrincipal(value);
            handleValidatedFieldChange("correoElectronicoPrincipal", value);
          }}
          maxLength={100}
        />
      </div>
      {getErrorMessage("correoElectronicoPrincipal") && (
        <p className={styles.errorMessage}>
          {getErrorMessage("correoElectronicoPrincipal")}
        </p>
      )}
      <div className={styles.showInProfileContainer}>
        <span className={styles.showInProfileText}>
          {t(SHOW_IN_PROFILE_KEY)}
        </span>
        <IconButton
          onClick={() => {
            setShowEmail(!showEmail);
            handleToggleChange(
              "mostrarCorreoElectronicoPrincipal",
              !showEmail,
            );
          }}
          size="small"
          className={styles.toggleButton}
          sx={{
            "& .MuiSvgIcon-root": {
              color: showEmail ? "#1d5ae8" : "#C7C8C8",
            },
          }}
        >
          {showEmail ? <ToggleOnIcon color="primary" /> : <ToggleOffIcon />}
        </IconButton>
      </div>
    </div>
  );
}

export function WebsiteField({ section }) {
  const {
    t,
    paginaInternet,
    setPaginaInternet,
    getFieldValidationState,
    getErrorMessage,
    handleValidatedFieldChange,
    showWebsite,
    setShowWebsite,
    handleToggleChange,
  } = section;

  return (
    <div className={`${styles.inputRow} ${styles.twoInputsRow}`}>
      <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
        <label className={styles.inputLabel}>
          {t("components.contactInformation.websiteLabel")}
        </label>
        <div className={styles.inputWrapper}>
          <WebsiteIcon className={styles.inputIcon} />
          <input
            type="text"
            className={`${styles.input} ${styles.inputWithIcon} ${
              styles.tabletWebsiteInput
            } ${
              getFieldValidationState("paginaInternet", paginaInternet) ===
              "error"
                ? styles.inputError
                : ""
            }`}
            placeholder={t("components.contactInformation.websitePlaceholder")}
            value={paginaInternet}
            onChange={(e) => {
              const value = e.target.value;
              setPaginaInternet(value);
              handleValidatedFieldChange("paginaInternet", value);
            }}
            maxLength={2083}
          />
        </div>
        {getErrorMessage("paginaInternet") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("paginaInternet")}
          </p>
        )}
        <div
          className={`${styles.showInProfileContainer} ${styles.lastShowInProfileContainer}`}
        >
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setShowWebsite(!showWebsite);
              handleToggleChange("mostrarPaginaInternet", !showWebsite);
            }}
            size="small"
            className={styles.toggleButton}
            sx={{
              "& .MuiSvgIcon-root": {
                color: showWebsite ? "#1d5ae8" : "#C7C8C8",
              },
            }}
          >
            {showWebsite ? (
              <ToggleOnIcon color="primary" />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
    </div>
  );
}
